// Use saved settlement metadata only. Missing data must not be guessed as cash.
export function exchangeReceipt(tx) {
  if (!tx?.return_credit_id || tx.return_credit_amount == null) return null;
  const n = value => Math.max(0, Number(value) || 0);
  return { amount:n(tx.return_credit_amount), replacement:n(tx.total), applied:n(tx.return_credit_applied),
    due:n(tx.grand_total ?? Math.max(0,n(tx.total)+n(tx.fee)+n(tx.settlement_total)-n(tx.return_credit_applied))),
    cash:n(tx.return_credit_cash_refund), balance:n(tx.return_credit_customer_balance) };
}
